export const GUEST_ID_HEADER = 'x-guest-id';
export const GUEST_TOKEN_HEADER = 'x-guest-token';
//# sourceMappingURL=constants.js.map